import { useEffect } from 'react';

const useOnClickOutside = (ref, handler, includes) => {
  useEffect(
    () => {
      const listener = async event => {
        const { target } = event;
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        if (includes && !!includes.length && target) {
          const containsClass = await includes.reduce((agg, item) => {
            if (target.classList.contains(item)) return agg.concat(item);
            return agg;
          }, []);

          if (containsClass && !!containsClass.length) return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
};

export default useOnClickOutside;
